howspace.components.picture = (() => {
    'use strict';

    const visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                visibilityObserver.unobserve(entry.target);
                const howspacePicture = entry.target.closest('.howspace-picture');
                howspacePicture.classList.add('is-visible');
                loadImage(howspacePicture);
            }
        });
    }, {
        // Use a 200px safety margin so that images will start loading already when they are close to the viewport.
        rootMargin : "200px 200px 200px 200px"
    });

    const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
            const imageWrapper = entry.target;
            const howspacePicture = imageWrapper.closest('.howspace-picture');
            if (!howspacePicture) {
                // Not attached to DOM anymore.
                resizeObserver.unobserve(imageWrapper);
                return;
            }

            if (howspacePicture.classList.contains('pause-resize')) {
                // Resizing is paused, do not resize.
                return;
            }

            if (!howspacePicture.classList.contains('is-visible')) {
                // Visibility observer has not loaded the image yet, do not resize.
                return;
            }

            const img = imageWrapper.querySelector('img');
            if (img) {
                const imageMaxWidth = parseInt(new URLSearchParams(img.src).get('maxwidth') || '0');
                const imageWrapperWidth = entry.contentRect.width;
                if (imageWrapperWidth <= imageMaxWidth) {
                    // There is an image already, but its max width param does not exceed the current wrapper width.
                    return;
                }
            }

            // Image wrapper resized to be larger than the current image wrapper width, reload the image.
            // Use a timeout to avoid requesting multiple images while animating or resizing rapidly.
            if (imageWrapper.dataset.resizeTimeoutId) {
                clearTimeout(imageWrapper.dataset.resizeTimeoutId);
            }
            imageWrapper.dataset.resizeTimeoutId = setTimeout(() => {
                delete imageWrapper.dataset.resizeTimeoutId;
                howspacePicture.classList.remove('replacing');
                loadImage(howspacePicture);
            }, 200);
        });
    });

    const getImageMaxWidth = (howspacePicture) => {
        // Get the proper image width by multiplying the image width with the device pixel ratio.
        const imageWrapper = howspacePicture.querySelector('.image-wrapper');
        const imageWrapperWidth = Math.ceil(imageWrapper.getBoundingClientRect().width * window.devicePixelRatio);

        // Ceil to the closest 200. So 0 = 0, 1 = 200, 139 = 200, 200 = 200, 201 = 400 and so on.
        const widthCeil200 = Math.ceil(imageWrapperWidth / 200) * 200;

        // Do not exceed the original width of the image (we don't upscale images).
        const originalWidth = parseInt(howspace.getCssVariable(howspacePicture, '--original-width').replace('px', ''));
        return Math.min(widthCeil200, originalWidth);
    };

    const loadImage = (howspacePicture) => {
        if (!howspacePicture) {
            return;
        }

        const imageWrapper = howspacePicture.querySelector('.image-wrapper');
        const imageSrc = howspacePicture.dataset.src;

        if (!imageSrc || !imageWrapper) {
            return;
        }

        if (howspacePicture.classList.contains('replacing')) {
            return;
        }

        howspacePicture.classList.add('replacing');

        const separator = imageSrc.includes('?') ? '&' : '?';
        const maxWidth = getImageMaxWidth(howspacePicture);
        const url = `${imageSrc}${separator}format=webp&maxwidth=${maxWidth}`;

        const readyFn = (url, newImage, loadTimeMs) => {
            howspacePicture.classList.remove('loading', 'replacing');

            newImage.addClass('new-image');
            newImage.attr('draggable', false);
            newImage.attr('alt', howspacePicture.dataset.altText);
            newImage.css('opacity', 0);
            imageWrapper.append(newImage[0]);

            // If the image was loaded in less than 100 ms, we skip the animation.
            const duration = loadTimeMs < 100 ? 0 : 350;
            howspace.animate(newImage, {opacity: 1}, duration, () => {
                howspacePicture.classList.remove('has-blur-image');
                imageWrapper.style.backgroundImage = '';
                imageWrapper.querySelector('img:not(.new-image)')?.remove();
                newImage.css('opacity', '');
                newImage.removeClass('new-image');

                howspace.dispatchEvent(howspacePicture, howspace.components.picture.PICTURE_LOADED);
            });
        };

        real.image.load(url, readyFn, false);
    };

    real.onTierReady(real.TIER_2, () => {
        real.events.on('uploadedfile:stored', (notification) => {
            if (notification.object.uploadedfile.metadata?.original_uploaded_file_id) {
                // We are replacing an existing image in the UI. This is handled on a case-by-case basis.
                return;
            }

            $('.howspace-picture[data-uploadedfile-id="' + notification.object.uploadedfile.id + '"]').each(function() {
                loadImage(this);
            });
        });

        real.events.on('uploadedfile:image:manipulated', (notification) => {
            // Check the CSS variables to find out if the logo or the background image was just manipulated.
            const logo = document.querySelector('#top .logo-wrapper img');

            if (logo?.src.indexOf(notification.object.uploadedfile.id) >= 0) {
                // Add "&v=2" GET parameter to the logo src to reload the logo.
                logo.src = logo.src.replace(/"\)$/, '&v=2")');
            }

            let rootWorkspaceVisuals = $('#root-workspace-visuals').html() || '';
            if (rootWorkspaceVisuals.indexOf(notification.object.uploadedfile.id) >= 0) {
                // Add "&v=2" GET parameter to the CSS url() to reload the background image.
                const urlRegex = new RegExp('url\\("[^"]+' + notification.object.uploadedfile.id + '[^"]+"\\)');
                const oldUrl = rootWorkspaceVisuals.match(urlRegex)[0] || null;
                if (oldUrl) {
                    const newUrl = oldUrl.replace(/"\)$/, '&v=2")');
                    rootWorkspaceVisuals = rootWorkspaceVisuals.replace(oldUrl, newUrl);
                    $('#root-workspace-visuals').html(rootWorkspaceVisuals);
                }
            }
        });
    });

    real.dom.$body.on('click', '.howspace-picture[data-allow-fullscreen="true"]', e => {
        const target = $(e.target);
        const picture = $(e.currentTarget);

        if (target.closest('.annotation-pin').length > 0) {
            return;
        }

        if (target.closest('.is-pinning').length > 0 || target.closest('.is-annotating').length > 0) {
            return;
        }

        if (!picture.data('uploadedfile-id')) {
            return;
        }

        const fileId = picture.data('uploadedfile-id');
        const url = real.baseUri + '/utils/fullscreen-viewer-modal?type=image&uploaded_file_id=' + fileId;
        howspace.components.modal.show(url, null, {fullScreen: true});
    });

    document.body.addEventListener('keydown', e => {
        if (
            e.key === 'Enter' &&
            document.activeElement &&
            document.activeElement.classList.contains('howspace-picture') &&
            document.activeElement.dataset.allowFullscreen === 'true'
        ) {
            document.activeElement.click();
        }
    });

    return {
        PICTURE_LOADED: 'howspace-picture-loaded',
        init: (elem) => {
            elem.findIncludingSelf('.howspace-picture:not(.howspace-picture-initialized)').each(function () {
                const picture = $(this);
                picture.addClass('howspace-picture-initialized');

                const imageWrapper = picture.find('.image-wrapper')[0];
                if (imageWrapper) {
                    visibilityObserver.observe(imageWrapper);
                    resizeObserver.observe(imageWrapper);
                }
            });
        },
        destroy: (elem) => {
            elem.findIncludingSelf('.howspace-picture.howspace-picture-initialized').each(function () {
                const picture = $(this);
                picture.removeClass('howspace-picture-initialized');

                const imageWrapper = picture.find('.image-wrapper')[0];
                if (imageWrapper) {
                    visibilityObserver.unobserve(imageWrapper);
                    resizeObserver.unobserve(imageWrapper);
                }
            });
        },
        replacePicture : (picture, uploadedFileId, newImageSrc, metadata) => {
            const imageWrapper = picture.querySelector('.image-wrapper');
            if (!imageWrapper) {
                return;
            }

            picture.classList.add('loading');
            picture.dataset.src = newImageSrc;
            picture.dataset.uploadedfileId = uploadedFileId;
            picture.style.setProperty('--original-width', metadata.width + 'px');
            picture.style.setProperty('--original-height', metadata.height + 'px');
            picture.style.setProperty('--aspect-ratio', metadata.width + ' / ' + metadata.height);

            if (metadata.height > 50) {
                picture.classList.add('show-spinner');
            }

            if (metadata.blur_image && !metadata.has_transparency) {
                picture.classList.add('has-blur-image');
                imageWrapper.style.backgroundImage = "url('" + metadata.blur_image + "')";
            } else {
                picture.classList.remove('has-blur-image');
                imageWrapper.style.backgroundImage = '';
            }

            imageWrapper.innerHTML = '';
            loadImage(picture);
        },
        pauseResize: (picture) => {
            if (picture instanceof jQuery) {
                picture = picture[0];
            }
            picture.classList.add('pause-resize');
        },
        continueResize: (picture) => {
            if (picture instanceof jQuery) {
                picture = picture[0];
            }
            picture.classList.remove('pause-resize');
        }
    };
})();
